<template>

  <div class="rc-row" :class="additional()" :cmpt="cmpt" :key="tagValue" :ref="refValue">
      <slot></slot>
  </div>

</template>

<script>

import { mapGetters } from 'vuex'

import StringUtils from "@/utils/StringUtils.js";

export default {
  name: 'portals-shared-library-box-row',
  props: {
    cmpt: { type: String, default: "row" },
    borderStyle: { type: String, default: "" },
    backgroundColour: { type: String, default: "" },
    tagValue: { type: String, default: "" },
    refValue: { type: String, default: "" },
    even:     { type: String, default: null },
    borderRadius: { type: String, default: "" },
    elevation:    { type: String, default: "" },
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters([
    ]),
  },
  created() {
    
    if (!this.$slots.default) {
      return;
    }
    const slots = this.$slots.default();
    const columns = slots.filter(node => {
      return typeof node.tag === 'string' && StringUtils.contains(node.tag, 'box-column');
    });
    if (columns) {
      var number = columns.length;
      if (number) {
        //
      }
    }
  },
  mounted() {
  },
  methods: {
    additional: function () {
      var value = "";
      if (this.even != null) {
        value += this.even == "true" ? " rc-border-thin-even " : " rc-border-thin ";
      } 
      if (!StringUtils.isEmpty(this.borderStyle)) {
        value = this.borderStyle + " ";
      }
      if (!StringUtils.isEmpty(this.backgroundColour)) {
        value += "rc-" + this.backgroundColour + " ";
      }
      if (!StringUtils.isEmpty(this.borderRadius) && this.borderRadius != "none") {
        value += "rc-border-radius-" + this.borderRadius + " ";
      }
      if (!StringUtils.isEmpty(this.elevation) && this.elevation != "none") {
        value += "rc-elevation-" + this.elevation + " ";
      }
      return value;
    },
  },
}
</script>